<template>
  <v-menu
    :close-on-content-click="false"
    v-model="isCalendarVisible"
    lazy
    transition="scale-transition"
    offset-y
    bottom
    offset-overflow
    full-width
    min-width="290px"
    class="date-picker-container date-field-wrapper"
  >
    <v-text-field
      placeholder="DD/MM/YYYY"
      slot="activator"
      :value="formattedDate"
      append-icon="event"
      solo
      clearable
      @click:clear="onClear"
      @change="handleChange"
      class="date-input"
      :readonly="shouldDisable"
    />
    <v-date-picker :value="date" @input="onPickedDate" :min="minDate" :max="maxDate" no-title></v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";

export default {
  name: "DateFilter",
  data() {
    return {
      isCalendarVisible: false
    };
  },
  props: {
    date: null,
    minDate: String,
    maxDate: String,
    meta: Object
  },
  computed: {
    formattedDate() {
      const date = this.date;
      if (!date) {
        return null;
      }
      return moment(date).format("DD/MM/YYYY");
    },
    shouldDisable() {
      return true;
    }
  },
  methods: {
    onPickedDate(val) {
      this.isCalendarVisible = false;
      this.$emit("date-update", val);
    },
    handleChange(val) {
      const momentDate = moment(val, "DD/MM/YYYY");
      const isValid = momentDate.isValid();
      if (isValid) {
        this.$emit("date-update", momentDate.format("YYYY-MM-DD"));
      }
    },
    onClear() {
      this.$emit("date-update", null);
    }
  }
};
</script>

<style lang="scss" scoped>
.date-field-wrapper {
  height: 60px;

  .theme--light.v-text-field.v-text-field--outline ::v-deep .v-input__control {
    .v-input__slot {
      border-color: rgba(0, 0, 0, 0.12);
      border-width: 1px;
    }

    .v-input__slot:hover {
      border-color: rgba(0, 0, 0, 0.12);
    }
  }
}

.mb-date-filter {
  width: 100% !important;
  .date-field-wrapper {
    height: 30px;
    .v-text-field > .v-input__slot::before {
      border-color: rgb(255, 0, 0) !important;
    }
    ::v-deep .v-input__slot {
      box-sizing: border-box;
      flex-direction: row;
      padding: 9px 13px 9px 14px !important;
      height: 30px !important;
      background: #ffffff !important;
      border: 1px solid #c9c9c9;
      border-radius: 5px !important;
      max-height: unset;
      min-height: unset;
    }

    ::v-deep .v-icon {
      font-size: 12px !important;
    }
    ::v-deep .v-text-field__slot input {
      font-family: "Montserrat" !important;
      font-style: normal !important;
      font-weight: 400 !important;
      font-size: 10px !important;
      line-height: 12px !important;
      color: #4d4d4d !important;
    }
  }
}
</style>
